(function ($, Drupal) {
  $(document).ready(function() {
    $('[id^="collapsable_card_"]').on('click', function (e) {
      let id = e.currentTarget.id.split("_")[2];
      let icon = $(e.currentTarget).find('i.icon-region');

      if (icon.attr('class') == "icon-region fas fa-sort-down") {
        icon.attr("class", "icon-region fas fa-sort-up");
      } else {
        icon.attr("class", "icon-region fas fa-sort-down");
      }
    });
  });
})(jQuery, Drupal);